import {
  GREEN,
  WHITE,
  PURPLE,
} from '@/ui-kit/theme';

export enum LoaderColor {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  AI = 'AI',
  CURRENT_COLOR = 'currentColor',
}

export const MAP_LOADER_COLOR_TO_COLOR: Record<LoaderColor, string> = {
  [LoaderColor.PRIMARY]: GREEN,
  [LoaderColor.SECONDARY]: WHITE,
  [LoaderColor.AI]: PURPLE,
  [LoaderColor.CURRENT_COLOR]: 'currentColor',
};
